import React, { useEffect } from "react";
import { useHistory } from "react-router";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";

const Develop = () => {
  const history = useHistory();
  history.push("/develop/programs");
  return <div className="develop"><LoadingSpinner/></div>;
};

export default Develop;
